import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "components/NoScrollDialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDInput from "components/MDInput";
import LoadingButton from "components/LoadingButton";
import { Grid } from "@mui/material";
import DropdownSelect from "components/DropdownSelect";
import { useLanguage } from "contexts/language.context";

export default function LanguagesEditNewDialog({
  isOpen,
  onSubmit,
  data,
  type,
}) {
  const { label } = useLanguage();
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [language, setLanguage] = React.useState({
    description: "",
  });

  React.useEffect(() => {
    if (!isOpen) return;
    setOpen(true);
    setLoading(false);
    setLanguage({
      description: "",
    });
  }, [isOpen]);

  React.useEffect(() => {
    setLanguage({ ...data });
  }, [data]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: "form",
        onSubmit: async (event) => {
          event.preventDefault();

          setLoading(true);
          const result = await onSubmit(language);
          if (result.success) {
            handleClose();
          }

          setLoading(false);
        },
      }}
    >
      <DialogTitle>
        {type == "edit" ? label("edit-language") : label("create-language")}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={1} sx={{ mt: -0.5 }}>
          <Grid item xs={12}>
            <MDInput
              autoFocus
              required
              margin="dense"
              id="name"
              name="name"
              label={label("name-singular")}
              type="text"
              value={language.name}
              onChange={(e) => {
                setLanguage({
                  ...language,
                  name: e.target.value,
                });
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              required
              margin="dense"
              id="code"
              name="code"
              label={label("code-singular")}
              type="text"
              value={language.id}
              onChange={(e) => {
                setLanguage({
                  ...language,
                  id: e.target.value,
                });
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <DropdownSelect
              id="rtl"
              name="rtl"
              label={label("direction-singular")}
              value={
                language.rtl
                  ? { value: "rtl", label: label("Right to left") }
                  : { value: "ltr", label: label("Left to right") }
              }
              options={[
                { value: "rtl", label: label("Right to left") },
                { value: "ltr", label: label("Left to right") },
              ]}
              onChange={(newValue) => {
                setLanguage({
                  ...language,
                  rtl: newValue.value == "rtl",
                });
              }}
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{label("cancel-button")}</Button>
        <LoadingButton
          loading={loading}
          type="submit"
          variant="gradient"
          color="info"
        >
          {type == "edit" ? label("save-button") : label("create-button")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
